import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaUserCircle, FaCalendarCheck } from "react-icons/fa";
import constants from "../../../constants";
import LoadMoreList from "../../../services/LoadMoreList";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
import GlobalViewFileModal from "../../../services/GlobalViewFileModal";
import { openNewTabWithId, redirectUrl } from "../../../services/GlobalUrls";
import { sortByVisitDateDesc } from "../../../services/GlobalSortByVisitDate";
const DailyLogsListMobile = ({ dailyLogsStatus, ...props }) => {
  const [dailylogs, SetDailyLogs] = useState([]);
  const [setFilter] = useState("");
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    const filterDailyLogs = props.dailylogs?.filter(
      (dailyLogs) =>
        dailyLogs.daily_logs_status ===
        (dailyLogsStatus ? dailyLogsStatus : "Pending")
    );
    SetDailyLogs(sortByVisitDateDesc(filterDailyLogs || []));
  }, [props.dailylogs, dailyLogsStatus]);
  const viewFileModal = (url, fileName) => {
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      setFileUrl(url);
      setFileName(fileName);
    } else {
      redirectUrl(url);
    }
  };

  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };

  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };

  const viewDailyLogData = (dailyLog) => {
    const id = dailyLog.cnd_daily_logs_id;
    if (id) {
      sessionStorage.setItem("dailyLogViewId", String(id));
      sessionStorage.setItem("dailyLogViewMode", "true");
      redirectUrl("/view-daily-log");
    }
  };

  //   Filter - Start
  const [inputValue, setInputValue] = useState("");
  const matchesSearchText = (dailyLog) => {
    const searchText = inputValue.toLowerCase();
    return (
      dailyLog.cnd_daily_logs_created_date.toLowerCase().includes(searchText) ||
      dailyLog.cnd_daily_logs_firstname.toLowerCase().includes(searchText) ||
      dailyLog.cnd_daily_logs_lastname.toLowerCase().includes(searchText) ||
      dailyLog.cnd_daily_logs_date.toLowerCase().includes(searchText)
    );
  };

  // Filter applied jobs based on the search text
  const filterRows = dailylogs ? dailylogs.filter(matchesSearchText) : [];
  //   Filter - End

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        {/* Search Start */}
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              {/* <label className="form-control-label text-right" for="search">
                Search
              </label> */}
              <div className="form-group form-group-default">
                <input
                  type="text"
                  name="search"
                  className="form-control "
                  placeholder="Enter here"
                  onInput={(event, value) => {
                    setInputValue(event.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Search End */}
        <div className="col-lg-12 col-md-12 m-b0 wrapper">
          <LoadMoreList
            data={filterRows}
            initialCount={5}
            noDataMessage="No Result Found"
            renderItem={(dailylog, i) => (
              <ul
                className="nav navbar-nav border border-grey p-4 mb-2"
                style={{ borderRadius: "20px" }}
                key={i}
              >
                <li className="text-dark">
                  <FaCalendarAlt className="mr-1 text-primary" />{" "}
                  {dailylog.cnd_daily_logs_created_date}
                </li>
                <li className="text-dark">
                  <FaUserCircle className="mr-1 text-primary" />{" "}
                  {dailylog.cnd_daily_logs_firstname +
                    " " +
                    dailylog.cnd_daily_logs_lastname}
                  {dailylog.cnd_daily_logs_upload_file && (
                    <a
                      onClick={() =>
                        viewFileModal(
                          constants.IMAGE_URL +
                            dailylog.cnd_daily_logs_upload_file_folder_path +
                            dailylog.cnd_daily_logs_upload_file
                        )
                      }
                      className={
                        "text-" +
                        (dailylog.cnd_daily_logs_upload_file.endsWith(".png") ||
                        dailylog.cnd_daily_logs_upload_file.endsWith(".jpg") ||
                        dailylog.cnd_daily_logs_upload_file.endsWith(".jpeg") ||
                        dailylog.cnd_daily_logs_upload_file.endsWith(".pdf")
                          ? "primary"
                          : "primary") +
                        " text-sm pull-right mt--2"
                      }
                    >
                      <u>View File</u>
                    </a>
                  )}
                </li>
                <li className="text-dark">
                  <FaCalendarCheck className="mr-1 text-primary" />{" "}
                  {dailylog.cnd_daily_logs_date}
                </li>
                {dailyLogsStatus == "Pending" && (
                  <li className="text-dark">
                    <a
                      className="btn btn-primary btn-sm pull-right mt-2 text-white"
                      onClick={() =>
                        openNewTabWithId(
                          dailylog.cnd_daily_logs_id,
                          "/update-daily-logs",
                          "current"
                        )
                      }
                    >
                      Complete
                    </a>
                  </li>
                )}
                {dailyLogsStatus == "Completed" && (
                  <li className="text-dark">
                    <a
                      className="btn btn-primary btn-sm pull-right mt-2 text-white"
                      onClick={() => viewDailyLogData(dailylog)}
                    >
                      <i className="fa fa-eye"></i> View
                    </a>
                  </li>
                )}
              </ul>
            )}
          />
        </div>
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        // fileName={fileName}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        title={"Uploaded Documents"}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    dailylogs: state.dailylogs.dailylogs,
  };
};

export default connect(mapStateToProps)(DailyLogsListMobile);
